import type { Editor } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';

import { defaultUiState, type UiState } from 'containers/Tiptap/components/tiptap-extension/ui-state-extension';

export function useUiEditorState(editor: Editor | null): UiState {
  return (
    useEditorState({
      editor,
      selector: ({ editor: selectorEditor }) => {
        if (!selectorEditor) return defaultUiState;

        const state = selectorEditor.storage.uiState;
        if (!state) {
          console.warn(
            'Editor storage uiState is not initialized. Ensure you have the uiState extension added to your editor.'
          );
          return defaultUiState;
        }

        return { ...defaultUiState, ...state };
      },
    }) ?? defaultUiState
  );
}

export default useUiEditorState;
